import { Box, Container } from "@mui/material";
import { navigationRoutes } from "common/constants/navigation-routes";
import {
  ExtraServiceMainHeader,
  ExtraServiceOffers,
  ExtraServiceReturnTerms,
} from "components/extra-services";
import { ExtraServiceFaq } from "components/extra-services/ExtraServiceFaq";
import ShopLayout1 from "components/layouts/ShopLayout1";
import LazyImage from "components/LazyImage";
import Navbar from "components/navbar/Navbar";
import { useRouter } from "next/router";
import { useRef } from "react";

const ExtraServicePage = ({}) => {
  const { push } = useRouter();
  const targetRef = useRef(null);

  const handleScrollToTarget = () => {
    if (targetRef.current) {
      targetRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const onNavigateDiyBuilder = () => {
    push(navigationRoutes?.diyBuilder);
  };

  return (
    <ShopLayout1 title="PCW Extra Services" navbar={<Navbar />}>
      <Container maxWidth="lg" sx={{ p: 2 }}>
        <ExtraServiceMainHeader />
        <Box mt={3} onClick={onNavigateDiyBuilder} sx={{ cursor: "pointer" }}>
          <LazyImage
            sx={{
              width: "100%",
              borderRadius: "8.8px",
              border: "2px solid red",
            }}
            width={1380}
            height={280}
            alt={`/assets/images/extra-service/we-make-it-worth-banner.png`}
            loading="eager"
            objectFit="contain"
            src={"/assets/images/extra-service/we-make-it-worth-banner.png"}
          />
        </Box>
        <ExtraServiceOffers onScroll={handleScrollToTarget} />
        <Box ref={targetRef}>
          <ExtraServiceReturnTerms />
        </Box>
        <ExtraServiceFaq />
      </Container>
    </ShopLayout1>
  );
};

export default ExtraServicePage;
